import { render, staticRenderFns } from "./BoxPager.vue?vue&type=template&id=2a7fe4ce&scoped=true&"
import script from "./BoxPager.vue?vue&type=script&lang=js&"
export * from "./BoxPager.vue?vue&type=script&lang=js&"
import style0 from "./BoxPager.vue?vue&type=style&index=0&id=2a7fe4ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fe4ce",
  null
  
)

export default component.exports